



























































































































import {
  defineComponent,
  useRoute,
  useRouter,
  ref,
  computed,
  useFetch,
  useContext
} from '@nuxtjs/composition-api'
import { useDep } from '~/compositions/dependency-container'
import { useI18n } from '~/compositions/i18n'
import { useNamespacedStore } from '~/compositions/store'

import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import CPagination from '~/components/shared/configurable/pagination/CPagination.vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import COpenStreetMap from '~/components/shared/configurable/map/COpenStreetMap.vue'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import CCategorySelect from '~/components/shared/configurable/category/select/CCategorySelect.vue'
import ListItem from '~/components/car/dealers/map/list/item/ListItem.vue'

import {
  UserAgentState,
  USER_AGENT_NS
} from '~/store/modules/shared/userAgent/state'

import DealersPreviewService from '~/services/dealers/preview/DealersPreviewService'
import ScrollService from '~/services/scroll/ScrollService'
import SnackbarService from '~/services/snackbar/SnackbarService'

import { handleError } from '~/utils/http'

import { SortOption } from '~/models/dealer/map/types'
import { PaginationAppearance } from '~/models/pagination'
import { Breadcrumb, Geolocation } from '~/models/common/types'
import { DealersPerPrefecture } from '~/models/dealer/types'

export default defineComponent({
  components: {
    CCustomSelect,
    CPagination,
    CBreadcrumbs,
    COpenStreetMap,
    CAvatar,
    CCategorySelect,
    ListItem
  },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const dealersPreviewService = useDep(DealersPreviewService)
    const scrollService = useDep(ScrollService)
    const snackbarService = useDep(SnackbarService)

    const { t } = useI18n()

    const { app } = useContext()

    const fetchedData = ref<DealersPerPrefecture | null>(null)
    const activeStyleTab = ref(0)
    const sort = ref<string | (string | null)[]>(
      route.value.query.sort || 'google_rating'
    )
    const page = ref(route.value.query.pg)
    const inputQuery = ref(route.value.query.q)
    const location = ref(route.value.query.location)

    const category = ref([])
    const loadCategoriesFromRoute = ref(true)

    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )

    const isMobile = computed(() => userAgentGetters('isMobile'))

    const { fetch } = useFetch(async () => {
      if (!category.value?.length && loadCategoriesFromRoute.value) {
        category.value = route.value.query.categories?.split(',')
      }

      try {
        fetchedData.value = await dealersPreviewService.filterDealersList({
          pg: page.value || '1',
          q: inputQuery.value || '',
          sort: sort.value || '',
          location: location.value,
          categories:
            category.value?.length || !loadCategoriesFromRoute.value
              ? category.value?.join(',')
              : route.value.query.categories
        })

        if (loadCategoriesFromRoute.value) loadCategoriesFromRoute.value = false

        router.replace({
          name: '__dealers_list_generic',
          query: {
            pg: page.value.toString(),
            q: inputQuery.value || '',
            sort: sort.value || 'google_rating',
            location: location.value,
            categories:
              category.value?.length || !loadCategoriesFromRoute.value
                ? category.value?.join(',')
                : route.value.query.categories
          }
        })
      } catch (error) {
        handleError(error as any, snackbarService, app.$logger, t)
      }
    })

    const sortingOptions = computed(
      () =>
        fetchedData.value?.sorting.map((opt: SortOption) => {
          return {
            text: opt.name,
            value: opt.value
          }
        })!
    )
    const selectedAppearance = computed(() => {
      switch (activeStyleTab.value) {
        case 0:
        default: {
          return PaginationAppearance.BUTTONS
        }
        case 1: {
          return PaginationAppearance.PLAIN
        }
      }
    })
    const breadcrumbs = computed((): Breadcrumb[] => {
      const bcArray = [
        {
          text: t('dealers') as string,
          url: router.resolve({
            name: '__dealers'
          }).href
        }
      ]
      location.value &&
        bcArray.push({
          text: fetchedData.value?.results.rows[0]?.location.prefecture.toUpperCase() as string,
          url: '#'
        })

      return bcArray
    })

    const handleSort = (newSort: string | (string | null)[]): void => {
      if (!fetchedData.value) return
      const index: number = fetchedData.value.sorting.findIndex(
        (so: SortOption) => so.value === sort.value
      )
      fetchedData.value.sorting[index].selected = true
      fetchedData.value.sorting.forEach((so: SortOption) => {
        if (so.value !== newSort) {
          so.selected = false
        }
      })
      page.value = '1'

      fetch()
    }

    const handleInputQuerySearch = () => {
      page.value = '1'

      fetch()
    }

    const handlePageChange = () => {
      fetch()

      scrollService.scrollToTopSmooth()
    }

    const handleCategorySelect = () => {
      page.value = '1'

      fetch()
    }

    const handleMarkerClick = (coords: Geolocation) => {
      window.open(
        `https://www.google.com/maps/dir/?api=1&destination=${coords.lat},${coords.lon}`,
        '_blank'
      )
    }

    return {
      fetchedData,
      sortingOptions,
      sort,
      selectedAppearance,
      handlePageChange,
      page,
      inputQuery,
      handleInputQuerySearch,
      breadcrumbs,
      handleSort,
      isMobile,
      handleMarkerClick,
      category,
      handleCategorySelect
    }
  }
})
